
import * as angular from "angular";
import * as moment from "moment";
import { IDriver } from "@interfaces/IDriver";
import { IVehicle } from "@interfaces/IVehicle";
import { IVehicleDriverMapping } from "@interfaces/IVehicleDriverMapping";
import { DriverService } from "@services/driver.service";
import { DriverAssignmentService } from "@services/driverAssignment.service";
import { VehicleService } from "@services/vehicle.service";
import "./vehicleDrivers.scss";

interface IVehicleDriversComponentController {
    vehicle: IVehicle;
}

interface IMappingWithData {
    mapping: IVehicleDriverMapping;
    vehicle: IVehicle;
    driver: IDriver;
    current: boolean;
    newDateStart: boolean;
    newDateEnd: boolean;
}

class VehicleDriversComponentController implements angular.IComponentController, IVehicleDriversComponentController {

    loading: boolean;

    vehicle: IVehicle;

    driverAssignments: IMappingWithData[] = [];

    static $inject = ["$q", "driverService", "driverAssignmentService", "vehicleService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly driverService: DriverService,
        private readonly driverAssignmentService: DriverAssignmentService,
        private readonly vehicleService: VehicleService) {
    }

    $onInit() {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj["vehicle"]) {
            this.updateLast25Drivers();
        }
    }

    private updateLast25Drivers() {
        this.driverAssignments = [];
        const start = moment().startOf("d");
        const end = moment().endOf("d");

        const vehiclePromise = this.vehicleService.getVehicles({ includePeripheralMappings: true });
        const driverAssignmentPromise = this.driverAssignmentService.getIntersectingDriverAssignmentsForVehicle(this.vehicle.Id, start, end);

        this.$q
            .all([vehiclePromise, driverAssignmentPromise])
            .then(([vehicles, [drivers, mappings]]) => {
                //this.driverService.mapDriversToVehicles(drivers, mappings, vehicles);

                var previousAssignment: IMappingWithData = null;

                mappings.forEach(mapping => {

                    const driver = this.driverService.findDriver(drivers, mapping.DriverId);
                    const vehicle = this.vehicleService.findVehicle(vehicles, mapping.VehicleId);

                    const endTime = moment(mapping.EndUtc);
                    const startTime = moment(mapping.StartUtc);
                    const isCurrent = !mapping.EndUtc || endTime.isAfter();
                    if (isCurrent) {
                        mapping.EndUtc = moment();
                    }

                    const assignment: IMappingWithData = {
                        mapping: mapping,
                        driver: driver,
                        vehicle: vehicle,
                        current: isCurrent,
                        newDateEnd: isCurrent || !previousAssignment || !endTime.isSame(previousAssignment.mapping.StartUtc, "date"),
                        newDateStart: !previousAssignment || !startTime.isSame(previousAssignment.mapping.EndUtc, "date")
                    };

                    this.driverAssignments.push(assignment);

                    previousAssignment = assignment;
                });

                // Get it in chronological order
                this.driverAssignments.sort((x, y) => {
                    return y.mapping.Id - x.mapping.Id;
                });

                // Limit to 25
                this.driverAssignments = this.driverAssignments.slice(0, 25);
            });
    }
}

export class VehicleDriversComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: boolean;

    constructor() {
        this.bindings = {
            vehicle: "<",
        };

        this.transclude = true;

        this.controller = VehicleDriversComponentController;
        this.template = require("./vehicleDrivers.html");
    }
}
